import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import ButtonNormal from '../form/ButtonNormal';
import GlobalErrorMessage from './errors/GlobalErrorMessage';

const ExcludePaths = [
  ''
]

const BrowserSizeError: React.FC = () => {
  const location = useLocation();

  const pathName = location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname;
  if (ExcludePaths.includes(pathName)) {
    return null;
  }

  return (
    <Container>
        <GlobalErrorMessage
          title="Nola出版は現在PC版でのみご利用いただけます。"
          titleSub={`スマートフォンでもご利用いただけるよう現在検討を進めておりますので、今しばらくお時間いただけますと幸いです。\nご不便をおかけし大変恐れ入りますが、取り急ぎはPCよりご利用の程何卒よろしくお願いいたします。`}
          contents={
            <ButtonArea>
              <ButtonNormal as={Link} to="/">トップに戻る</ButtonNormal>
            </ButtonArea>
          } />
    </Container>
  )
}

export default BrowserSizeError;

const Container = styled.div`
  /* Medium devices (landscape tablets, 768px and up) */
  @media (min-width: 768px) {
    display: none;
  }
`;

const ButtonArea = styled.div`
  margin-top: 50px;
`;